import script from "./UserList.vue?vue&type=script&setup=true&lang=js"
export * from "./UserList.vue?vue&type=script&setup=true&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=690a1ef5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-690a1ef5"]])

export default __exports__